export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_ERROR = 'GET_ORDER_ERROR';

export const ADD_ORDER_REQUEST = 'ADD_ORDER_REQUEST';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
export const ADD_ORDER_ERROR = 'ADD_ORDER_ERROR';

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_ERROR = 'UPDATE_ORDER_ERROR';

export const DELETE_ORDER_REQUEST = 'DELETE_ORDER_REQUEST';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_ERROR = 'DELETE_ORDER_ERROR';

export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const GET_ORDER_DETAILS_ERROR = 'GET_ORDER_DETAILS_ERROR';

export const ORDER_ACTION_REQUEST = 'ORDER_ACTION_REQUEST';
export const ORDER_ACTION_SUCCESS = 'ORDER_ACTION_SUCCESS';
export const ORDER_ACTION_ERROR = 'ORDER_ACTION_ERROR'; 

export const UPDATE_SWAP_STOCK_REQUEST = 'UPDATE_SWAP_STOCK_REQUEST';
export const UPDATE_SWAP_STOCK_SUCCESS = 'UPDATE_SWAP_STOCK_SUCCESS';
export const UPDATE_SWAP_STOCK_ERROR = 'UPDATE_SWAP_STOCK_ERROR';

export const UPDATE_SWAP_SHIPMENT_REQUEST = 'UPDATE_SWAP_SHIPMENT_REQUEST';
export const UPDATE_SWAP_SHIPMENT_SUCCESS = 'UPDATE_SWAP_SHIPMENT_SUCCESS';
export const UPDATE_SWAP_SHIPMENT_ERROR = 'UPDATE_SWAP_SHIPMENT_ERROR';